const ListItem = ({item}) => {
    return (
        <>
            <li className="my-1" >
                <a href="" className="text-slate-400">{item.item}</a>
            </li>
        </>
    )
}
export default ListItem;